/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import { FormattedReactMessage } from 'LearningCenterUI/components/I18n';
import styled from 'styled-components';
import VidyardVideoPlayer from 'ui-addon-video-player/components/VidyardVideoPlayer';
import UIButton from 'UIComponents/button/UIButton';
import H1 from 'UIComponents/elements/headings/H1';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UISection from 'UIComponents/section/UISection';
import { KOALA } from 'HubStyleTokens/colors';
import { onboardingSettingsExperienceMap, onboardingSettingsHubMap } from '../../constants/GettingStatedConsts';
import { setUserGuideSettingsAndReturnUrl } from '../../actions/GettingStartedActions';
import { connect } from 'react-redux';
import { getPricingPageUrl } from '../../utils/RoutingUtils';
import { getHighestHubPlan } from '../../utils/pricingUtils';
import { getAccountsProductsByPortal } from '../../selectors/accountsSelectors';
import Small from 'UIComponents/elements/Small';
import UsageTracker from '../../utils/UsageTracker';
import { GRID_BREAKPOINT_MEDIUM, GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import useMediaQuery from '../../hooks/useMediaQuery';
const StyledSection = styled(UISection).withConfig({
  displayName: "ModalVideoSection__StyledSection",
  componentId: "sc-8v0e9h-0"
})(["padding:40px;@media (max-width:", "){padding:16px;}"], GRID_BREAKPOINT_SMALL);
const RoundedVideoContainer = styled.div.withConfig({
  displayName: "ModalVideoSection__RoundedVideoContainer",
  componentId: "sc-8v0e9h-1"
})(["border-radius:5px;overflow:hidden;"]);
const hubVideoId = {
  marketing: '6ozr6ZpjbmPd3yhn1NndAp',
  sales: 'pbB2M5eoV1dqAbntdzFoKv',
  service: 'vTw7mU3bcSo45R254UHYza'
};

const ModalVideoSection = ({
  portalId,
  hub,
  sectionProps,
  setOnboardingSettings,
  onCTAClick,
  ownedProducts
}) => {
  const isMediumSize = useMediaQuery(`(max-width: ${GRID_BREAKPOINT_MEDIUM})`);
  return /*#__PURE__*/_jsx(StyledSection, Object.assign({}, sectionProps, {
    children: /*#__PURE__*/_jsxs(UIGrid, {
      children: [/*#__PURE__*/_jsxs(UIGridItem, {
        className: isMediumSize && 'm-bottom-3',
        size: {
          md: 8,
          xs: 12
        },
        children: [/*#__PURE__*/_jsx(RoundedVideoContainer, {
          children: /*#__PURE__*/_jsx(VidyardVideoPlayer, {
            loadingBackground: KOALA,
            onFinish: () => {
              UsageTracker.track('interaction', {
                action: 'academy-to-software-modal-video-finished',
                hub,
                ownedPlan: getHighestHubPlan(ownedProducts, hub)
              });
            },
            onPlay: () => {
              UsageTracker.track('interaction', {
                action: 'academy-to-software-modal-video-played',
                hub,
                ownedPlan: getHighestHubPlan(ownedProducts, hub)
              });
            },
            videoId: hubVideoId[hub]
          })
        }), /*#__PURE__*/_jsx(Small, {
          className: "m-top-2",
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.softwareDesirability.modal.videoSection.helpText"
          })
        })]
      }), /*#__PURE__*/_jsx(UIGridItem, {
        size: {
          md: 4
        },
        style: {
          textAlign: 'left'
        },
        children: /*#__PURE__*/_jsxs(UIFlex, {
          align: "stretch",
          direction: "column",
          justify: "between",
          style: {
            height: '100%'
          },
          children: [/*#__PURE__*/_jsxs(UIBox, {
            className: isMediumSize && 'm-bottom-3',
            children: [/*#__PURE__*/_jsx(H1, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `learningCenter.softwareDesirability.modal.hubs.${hub}.videoSection.heading`
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.softwareDesirability.modal.hubs.${hub}.videoSection.subheading`
            })]
          }), /*#__PURE__*/_jsx(UIBox, {
            children: /*#__PURE__*/_jsxs(UIFlex, {
              align: "center",
              direction: "column",
              children: [/*#__PURE__*/_jsxs(UIButton, {
                "data-test-id": "academy-to-software-desirability-modal-video-section-user-guide-button",
                onClick: () => {
                  UsageTracker.track('interaction', {
                    action: 'academy-to-software-modal-user-guide-click',
                    hub,
                    ownedPlan: getHighestHubPlan(ownedProducts, hub),
                    section: 'video'
                  });
                  setOnboardingSettings(onboardingSettingsHubMap[hub.toUpperCase()], onboardingSettingsExperienceMap.NO_EXPERIENCE).then(redirectUrl => {
                    onCTAClick();
                    window.open(redirectUrl, '_blank');
                  });
                },
                style: {
                  width: '100%',
                  height: '52px'
                },
                use: "primary",
                children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
                  message: `learningCenter.softwareDesirability.modal.${getHighestHubPlan(ownedProducts, hub) === 'free' ? 'primaryCTA' : 'primaryCTAPaid'}`,
                  options: {
                    hubName: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: `learningCenter.softwareDesirability.modal.hubs.${hub}.name`
                    })
                  }
                }), /*#__PURE__*/_jsx(UIIcon, {
                  name: "externalLink",
                  size: 16
                })]
              }), /*#__PURE__*/_jsx(UILink, {
                className: "m-top-3",
                "data-test-id": "academy-to-software-desirability-modal-video-section-features-button",
                external: true,
                href: getPricingPageUrl(portalId, hub),
                onClick: () => {
                  UsageTracker.track('interaction', {
                    action: 'academy-to-software-modal-features-pricing-click',
                    hub,
                    ownedPlan: getHighestHubPlan(ownedProducts, hub),
                    section: 'video'
                  });
                  onCTAClick();
                },
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.softwareDesirability.modal.secondaryCTA"
                })
              })]
            })
          })]
        })
      })]
    })
  }));
};

const mapStateToProps = state => {
  return {
    portalId: state.auth.portal.portal_id,
    ownedProducts: getAccountsProductsByPortal(state)
  };
};

const mapDispatchToProps = {
  setOnboardingSettings: setUserGuideSettingsAndReturnUrl
};
export default connect(mapStateToProps, mapDispatchToProps)(ModalVideoSection);